import { render, staticRenderFns } from "./water2.vue?vue&type=template&id=f2bca79c&scoped=true"
import script from "./water2.vue?vue&type=script&lang=js"
export * from "./water2.vue?vue&type=script&lang=js"
import style0 from "./water2.vue?vue&type=style&index=0&id=f2bca79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bca79c",
  null
  
)

export default component.exports